import { useMemo } from 'react';
import { useTheme } from 'styled-components';

const useGradient = (showGradient: boolean) => {
	const theme = useTheme();
	return useMemo(() => {
		return (
			showGradient && {
				'background-size': `100% 100%`,
				'background-position': `0px 0px, 0px 0px, 0px 0px, 0px 0px, 0px 0px, 0px 0px, 0px 0px, 0px 0px,
			0px 0px`,
				'background-image': theme.gradient,
			}
		);
	}, [showGradient]);
};

export default useGradient;
